exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".projesecim,.projesecim svg{position:relative}.projesecim svg{z-index:2;fill:#fff}.projesecim span{font-family:Gilroy,sans-serif;font-weight:600;position:relative;font-size:10px;z-index:1;border-radius:2px;width:100%;white-space:nowrap;overflow:hidden;display:block;text-overflow:ellipsis;top:-5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-011baf78","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/comp/Index.vue
// module id = 123
// module chunks = 0